<form-control-container #container [control]="controlInstance">
  <div class="copyable-wrapper">
    <div label-extension>
      <ng-content select="[label-extension]"></ng-content>
    </div>

    <ng-container *ngIf="!isReadonlyValue">
      <textarea #copyableInput type="text" class="form-control copyable-text-area" [(ngModel)]="value" [ngClass]="{invalid: invalid}"
                [attr.maxLength]="maxLength"></textarea>
                <button class="btn btn-default btn-copy" (click)="copy()"></button>
    </ng-container>

    <ng-container *ngIf="isReadonlyValue">
      <span class="readonly-value" innerHTML="{{ value }}"></span>
    </ng-container>
  </div>
</form-control-container>